import React from 'react';
import cx from 'classnames';
import GroupAccordeon from './GroupAccordeon/index.js';
import styles from './index.module.scss.js';

const FooterList = ({
  casinoLinks,
  promoLinks,
  sportsLinks,
  supportLinks,
  className,
  style,
  ...props
}) => /* @__PURE__ */ React.createElement("div", { ...props, className: cx(styles.box, className), style }, /* @__PURE__ */ React.createElement("div", { className: cx(styles.box__inner, "footer-list") }, /* @__PURE__ */ React.createElement("div", { className: styles.col }, /* @__PURE__ */ React.createElement(GroupAccordeon, { data: casinoLinks })), /* @__PURE__ */ React.createElement("div", { className: styles.col }, /* @__PURE__ */ React.createElement(GroupAccordeon, { data: sportsLinks }), /* @__PURE__ */ React.createElement(GroupAccordeon, { data: promoLinks })), /* @__PURE__ */ React.createElement("div", { className: styles.col }, /* @__PURE__ */ React.createElement(GroupAccordeon, { data: supportLinks }))));
FooterList.displayName = "FooterComponent.List";

export { FooterList };
//# sourceMappingURL=index.js.map
